import React from "react";
import { Lightning } from "@phosphor-icons/react";

export const ShockSaleMarquee = () => {
  const items = [
    "RTX 4090 — $1599",
    "MacBook Pro M3 Max — $3499",
    "Ryzen 9 7950X3D — $549",
    "LG OLED 240Hz — $799",
    "Samsung 990 PRO 2TB — $169",
    "Keychron Q1 Pro — $199",
    "ROG Strix G16 — $1799",
  ];
  const all = [...items, ...items];

  return (
    <div className="bg-[#FF2A00] text-white py-3 overflow-hidden border-y-2 border-zinc-950">
      <div className="flex whitespace-nowrap animate-marquee">
        {all.map((t, i) => (
          <div key={i} className="flex items-center gap-3 px-6 font-mono font-bold text-sm uppercase tracking-wider">
            <Lightning size={14} weight="fill" /> {t}
          </div>
        ))}
      </div>
    </div>
  );
};
